/* ══════════════════════════════════════════════════════════
   YOURAYOU — Global JavaScript
   Scroll reveal, nav, mega menu, search, footer, cart API
   ══════════════════════════════════════════════════════════ */

/* 1. Scroll Reveal — IntersectionObserver for .reveal elements */
(function() {
  var revObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('on'); revObs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function(el) { revObs.observe(el); });
})();

/* 2. Mobile Menu — fullmenu + backdrop */
(function() {
  var hamburger = document.querySelector('.nav-hamburger');
  var fullmenu = document.getElementById('fullmenu');
  var closeBtn = document.getElementById('fullmenu-close');
  var backdrop = document.getElementById('fullmenu-backdrop');

  if (!hamburger || !fullmenu) return;

  function openMenu() {
    fullmenu.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    fullmenu.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  /* Section accordion toggles */
  document.querySelectorAll('.fullmenu-cat').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sec = btn.closest('.fullmenu-section');
      var isOpen = sec.classList.contains('open');
      document.querySelectorAll('.fullmenu-section').forEach(function(s) { s.classList.remove('open'); });
      if (!isOpen) sec.classList.add('open');
    });
  });

  /* Sub-section accordion toggles */
  document.querySelectorAll('.fullmenu-sub-cat').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sec = btn.closest('.fullmenu-sub-section');
      var isOpen = sec.classList.contains('open');
      btn.closest('.fullmenu-sub').querySelectorAll('.fullmenu-sub-section').forEach(function(s) { s.classList.remove('open'); });
      if (!isOpen) sec.classList.add('open');
    });
  });

  /* Expose closeMenu for search integration */
  window._yaCloseMenu = closeMenu;
})();

/* 3. Mega Menu — hover with 200ms close timer */
(function() {
  var megaCloseTimer = null;
  document.querySelectorAll('.nav-left > li').forEach(function(li) {
    var menu = li.querySelector('.mega-menu');
    if (!menu) return;
    li.addEventListener('mouseenter', function() {
      clearTimeout(megaCloseTimer);
      menu.classList.add('active');
    });
    li.addEventListener('mouseleave', function() {
      megaCloseTimer = setTimeout(function() { menu.classList.remove('active'); }, 200);
    });
    menu.addEventListener('mouseenter', function() { clearTimeout(megaCloseTimer); });
    menu.addEventListener('mouseleave', function() {
      megaCloseTimer = setTimeout(function() { menu.classList.remove('active'); }, 200);
    });
  });
})();

/* 4. Search Panel — desktop right-slide + mobile bottom sheet */
(function() {
  var searchBtn = document.getElementById('search-btn');
  var searchPanel = document.getElementById('search-panel');
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose = document.getElementById('search-panel-close');
  var searchBigClose = document.getElementById('search-big-close');
  var searchSheet = document.getElementById('search-sheet');
  var searchSheetBackdrop = document.getElementById('search-sheet-backdrop');
  var searchSheetClose = document.getElementById('search-sheet-close');
  var fullmenuSearchBtn = document.getElementById('fullmenu-search-btn');

  function isMobile() { return window.innerWidth <= 768; }

  function openSearch() {
    if (isMobile()) {
      if (searchSheet) {
        searchSheet.classList.add('open');
        if (searchSheetBackdrop) searchSheetBackdrop.classList.add('open');
        document.body.style.overflow = 'hidden';
        setTimeout(function() {
          var inp = searchSheet.querySelector('.search-sheet-input');
          if (inp) inp.focus();
        }, 350);
      }
    } else {
      if (searchPanel) searchPanel.classList.add('open');
      if (searchOverlay) searchOverlay.classList.add('open');
      if (searchBigClose) searchBigClose.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        var inp = searchPanel && searchPanel.querySelector('.search-input');
        if (inp) inp.focus();
      }, 300);
    }
  }

  function closeSearch() {
    if (searchPanel) searchPanel.classList.remove('open');
    if (searchOverlay) searchOverlay.classList.remove('open');
    if (searchBigClose) searchBigClose.classList.remove('open');
    if (searchSheet) searchSheet.classList.remove('open');
    if (searchSheetBackdrop) searchSheetBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (searchBtn) searchBtn.addEventListener('click', function(e) { e.stopPropagation(); openSearch(); });

  if (fullmenuSearchBtn) fullmenuSearchBtn.addEventListener('click', function() {
    if (window._yaCloseMenu) window._yaCloseMenu();
    setTimeout(openSearch, 200);
  });

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  if (searchSheetClose) searchSheetClose.addEventListener('click', function() {
    closeSearch();
    /* Return to fullmenu after closing mobile search */
    setTimeout(function() {
      var fullmenu = document.getElementById('fullmenu');
      var backdrop = document.getElementById('fullmenu-backdrop');
      if (fullmenu) fullmenu.classList.add('open');
      if (backdrop) backdrop.classList.add('open');
      document.body.style.overflow = 'hidden';
    }, 200);
  });

  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
  if (searchBigClose) searchBigClose.addEventListener('click', closeSearch);

  if (searchSheet) searchSheet.addEventListener('click', function(e) { e.stopPropagation(); });

  document.addEventListener('click', function(e) {
    if (searchSheet && searchSheet.classList.contains('open')
        && !searchSheet.contains(e.target) && e.target !== searchBtn) {
      closeSearch();
    }
  });

  /* Cursor-tracking big X button on search overlay */
  document.addEventListener('mousemove', function(e) {
    if (!searchBigClose || !searchBigClose.classList.contains('open')) return;
    searchBigClose.style.left = e.clientX + 'px';
    searchBigClose.style.top = e.clientY + 'px';
    var panelRect = searchPanel ? searchPanel.getBoundingClientRect() : null;
    if (panelRect) {
      var inside = e.clientX >= panelRect.left && e.clientX <= panelRect.right
                && e.clientY >= panelRect.top  && e.clientY <= panelRect.bottom;
      searchBigClose.style.opacity = inside ? '0' : '1';
    }
  });
})();

/* 4b. Predictive Search — fetch results from Shopify Suggest API */
(function() {
  var searchInputs = document.querySelectorAll('[data-search-input]');
  var debounceTimer;

  searchInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = this.value.trim();
      var wrap = this.closest('.search-input-wrap, .search-sheet-input-wrap');
      var resultsContainer = wrap ? wrap.querySelector('[data-search-results]') : null;

      if (!resultsContainer) return;

      if (query.length < 2) {
        resultsContainer.classList.remove('active');
        resultsContainer.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources.results.products || [];
            var pages = data.resources.results.pages || [];
            var articles = data.resources.results.articles || [];
            var html = '';

            products.forEach(function(p) {
              var img = p.image ? '<img class="search-result-img" src="' + p.image + '" alt="">' : '';
              var price = p.price ? '<div class="search-result-price">' + p.price + '</div>' : '';
              html += '<a class="search-result-item" href="' + p.url + '">'
                + img + '<div><div class="search-result-title">' + p.title + '</div>' + price + '</div></a>';
            });

            pages.forEach(function(p) {
              html += '<a class="search-result-item" href="' + p.url + '">'
                + '<div><div class="search-result-title">' + p.title + '</div></div></a>';
            });

            articles.forEach(function(a) {
              html += '<a class="search-result-item" href="' + a.url + '">'
                + '<div><div class="search-result-title">' + a.title + '</div></div></a>';
            });

            if (!html) {
              var noResultsText = resultsContainer.getAttribute('data-no-results') || 'No results found';
              html = '<div class="search-no-results">' + noResultsText + '</div>';
            }

            resultsContainer.innerHTML = html;
            resultsContainer.classList.add('active');
          })
          .catch(function() {
            resultsContainer.classList.remove('active');
          });
      }, 300);
    });
  });

  /* Close results when clicking outside */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-search-input]') && !e.target.closest('[data-search-results]')) {
      document.querySelectorAll('[data-search-results]').forEach(function(el) {
        el.classList.remove('active');
        el.innerHTML = '';
      });
    }
  });
})();

/* 5. Footer Accordion — mobile toggles */
(function() {
  document.querySelectorAll('.footer-acc-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.footer-acc-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.footer-acc-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
})();

/* 6. Cart API — uses Section Rendering API for DOM updates */
var YOURAYOUCart = {
  /**
   * All mutating calls include `sections: 'custom-main-cart'` in the request body.
   * Shopify returns { sections: { 'custom-main-cart': '<html>...</html>' } }
   * which we use to replace the cart container innerHTML.
   */
  getCart: function() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  },

  /* Parse une réponse /cart/*.js. Sur réponse non-OK (ex: 422 rupture),
     marque l'objet `_error` pour que les appelants affichent un message
     au lieu d'échouer en silence. Le chemin nominal est inchangé. */
  _parse: function(r) {
    return r.json().then(function(data) {
      data = data || {};
      if (!r.ok) { data._error = true; }
      return data;
    }, function() {
      return { _error: true, description: 'Réponse panier illisible (' + r.status + ')' };
    });
  },

  addToCart: function(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        properties: properties || {},
        sections: 'custom-main-cart,custom-cart-drawer'
      })
    }).then(YOURAYOUCart._parse);
  },

  updateCart: function(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: 'custom-main-cart,custom-cart-drawer'
      })
    }).then(YOURAYOUCart._parse);
  },

  removeFromCart: function(key) {
    return this.updateCart(key, 0);
  },

  /**
   * Replaces cart section HTML with server-rendered version.
   * Usage: YOURAYOUCart.updateCart(key, qty).then(YOURAYOUCart.renderSection);
   */
  renderSection: function(response) {
    if (response.sections && response.sections['custom-main-cart']) {
      var container = document.getElementById('cart-section');
      if (container) {
        container.innerHTML = new DOMParser()
          .parseFromString(response.sections['custom-main-cart'], 'text/html')
          .querySelector('.shopify-section').innerHTML;
      }
    }
    return response;
  },

  /**
   * Updates the cart count badge in the nav.
   * Call after any cart mutation: YOURAYOUCart.addToCart(...).then(YOURAYOUCart.updateBadge);
   */
  updateBadge: function(response) {
    YOURAYOUCart.getCart().then(function(cart) {
      var badges = document.querySelectorAll('.cart-count-badge');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
    });
    return response;
  }
};
